var _defs, _g, _defs2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInviteFailed = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .invite-failed-class-a {\n        fill: white;\n      }\n      .invite-failed-class-b {\n        fill: none !important;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_530_6125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2 4H4.688C4.24154 4.00159 3.81394 4.1802 3.49899 4.49664C3.18404 4.81309 3.00747 5.24154 3.008 5.688L3 15.819C3.00132 16.2663 3.17958 16.6949 3.49586 17.0111C3.81214 17.3274 4.24072 17.5057 4.688 17.507H11.442V15.819H4.688V7.377L11.442 11.6L18.2 7.377V10.684H19.888V5.684C19.8856 5.23741 19.7069 4.80985 19.3907 4.49444C19.0746 4.17903 18.6466 4.00131 18.2 4ZM11.442 9.909L4.688 5.688H18.2L11.442 9.909Z",
    className: "invite-failed-class-a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 15.641C21 14.8062 20.7524 13.9901 20.2886 13.296C19.8248 12.6018 19.1656 12.0608 18.3943 11.7414C17.623 11.4219 16.7743 11.3383 15.9555 11.5012C15.1367 11.664 14.3846 12.066 13.7943 12.6563C13.204 13.2467 12.802 13.9988 12.6391 14.8176C12.4762 15.6364 12.5598 16.4851 12.8793 17.2564C13.1988 18.0276 13.7398 18.6869 14.4339 19.1507C15.1281 19.6145 15.9442 19.862 16.779 19.862C17.3335 19.8626 17.8826 19.7538 18.3949 19.5418C18.9073 19.3299 19.3728 19.019 19.7649 18.6269C20.1569 18.2349 20.4678 17.7693 20.6798 17.257C20.8917 16.7446 21.0005 16.1955 21 15.641ZM15.391 17.879L14.569 17.057L15.969 15.657L14.557 14.237L15.329 13.465L16.745 14.881L18.195 13.431L19.017 14.253L17.567 15.703L18.955 17.091L18.183 17.863L16.8 16.474L15.391 17.879Z",
    className: "invite-failed-class-a"
  }))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_530_6125"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    className: "invite-failed-class-b"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInviteFailed);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/invite_failed.171fbc339f20e0aea84eb8ab8161c278.svg";